function useLocationsHook() {
    let locations = [
        {
            "name": "Argentina",
            "code": "AR",
            "currency": "USD",
            "symbol": "$"
        },
        {
            "name": "Bolivia",
            "code": "BO",
            "currency": "BOB",
            "symbol": "Bs."
        },
        {
            "name": "Chile",
            "code": "CL",
            "currency": "USD",
            "symbol": "$"
        },
        {
            "name": "Colombia",
            "code": "CO",
            "currency": "COP",
            "symbol": "$"
        },
        {
            "name": "Costa Rica",
            "code": "CR",
            "currency": "CRC",
            "symbol": "₡"
        },
        {
            "name": "Ecuador",
            "code": "EC",
            "currency": "USD",
            "symbol": "$"
        },
        {
            "name": "El Salvador",
            "code": "SV",
            "currency": "USD",
            "symbol": "$"
        },
        {
            "name": "Estados Unidos",
            "code": "US",
            "currency": "USD",
            "symbol": "$"
        },
        {
            "name": "Guatemala",
            "code": "GT",
            "currency": "GTQ",
            "symbol": "Q"
        },
        {
            "name": "Honduras",
            "code": "HN",
            "currency": "HNL",
            "symbol": "L"
        },
        {
            "name": "México",
            "code": "MX",
            "currency": "MXN",
            "symbol": "$"
        },
        {
            "name": "Nicaragua",
            "code": "NI",
            "currency": "NIO",
            "symbol": "C$"
        },
        {
            "name": "Panamá",
            "code": "PA",
            "currency": "USD",
            "symbol": "$"
        },
        {
            "name": "Paraguay",
            "code": "PY",
            "currency": "PYG",
            "symbol": "₲"
        },
        {
            "name": "Perú",
            "code": "PE",
            "currency": "PEN",
            "symbol": "S/."
        },
        {
            "name": "Uruguay",
            "code": "UY",
            "currency": "UYU",
            "symbol": "$"
        },
        {
            "name": "Venezuela",
            "code": "VE",
            "currency": "USD",
            "symbol": "$"
        }
    ];
    if (window.holacarrentals != undefined) {
        locations = window.holacarrentals.locations;
    }
    return locations;
}
export default useLocationsHook;
